import { useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../../../support/uiStateKeys';
import useDownloadAgreementsData from '../../../api/download/useDownloadAgreementsData';
import useOnLoadConfigData from '../../../api/load/useOnLoadConfigData';
import { type AcquisitionType } from '../../../../support/acquisitionTypes';
import { type AssetDownloadAgreementsResponse } from '../../../../../types/isomorphic/download.types';

interface AcquisitionConfigResult {
  acquisitionType: AcquisitionType | null;
  downloadAgreements: AssetDownloadAgreementsResponse | null;
  hasRfSubscription: boolean;
  batchAgreements: unknown[] | null;
}

const useAcquisitionConfig = (
  assetId: string | undefined
): AcquisitionConfigResult => {
  const queryClient = useQueryClient();

  // UI state: the modal's current acquisition-type/view-stack, not server data.
  const acquisitionTypeData = queryClient.getQueryData<{
    acquisitionType: AcquisitionType | null;
  }>([
    queryKeys.REMOVE_QUERY_ON_MODAL_CLOSE,
    queryKeys.ACQUISITION_TYPE,
    queryKeys.ACQUISITION_VIEW_STACK,
  ]);
  const acquisitionType = acquisitionTypeData?.acquisitionType ?? null;

  const downloadAgreements = useDownloadAgreementsData(assetId);
  const { hasRfSubscription, batchAgreements } =
    useOnLoadConfigData(acquisitionType);

  return {
    acquisitionType,
    downloadAgreements,
    hasRfSubscription,
    batchAgreements,
  };
};

export default useAcquisitionConfig;
